<template>
<nav class="navbar fixed-top navbar-expand-lg navbar-custom">
  <div class="container-fluid">
      <a class="navbar-brand font-13rem" href="tel:+36305485302" @click="googleAnalytics.fireDialEvent()">+36 (30) 548 5302</a>
      <button class="navbar-toggler" type="button" @click="togglerClicked()" aria-label="Toggle navigation">
        <span class="bi bi-caret-down-square-fill"></span>
      </button>
      <div class="navbar-collapse nav-menu-container" :class="{collapse: navCollapse}">
      <ul class="navbar-nav me-auto my-2 my-lg-0 nav-menu-list">
        <li class="nav-item" 
          v-for="link in navbarLinks" :key="link.id">
          <a class="nav-link  font-13rem" :href="link.href">{{ link.name }}</a>
        </li>
      </ul>
    </div>
    <a class="navbar-brand font-13rem small-none" href="tel:+36302766007" @click="googleAnalytics.fireDialEvent()">+36 (30) 276 6007</a>
  </div>
</nav>
</template>

<script>
import * as googleAnalytics from "@/utils/google-analytics-utils";

export default {
  name: 'NavBar',
  computed: {
    googleAnalytics() {
      return googleAnalytics
    }
  },
  props: {
  },
  data() {
    return {
      navCollapse: true,
      navbarLinks: [
        { name: "Rólunk", href: "/#bemutatkozas", id: 0 },
        { name: "Javítás", href: "/#javitas", id: 1 },
        { name: "Termékek", href: "/termekek", id: 2 },
        { name: "Kapcsolat", href: "/#kapcsolat", id: 3 },
      ]
    }
  },
  methods: {
    togglerClicked() {
      this.navCollapse = !this.navCollapse;
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/assets/style/common';
@use '@/assets/style/variables';
@use '@/assets/style/functions';

.nav-menu-container {
  justify-content: center;
}

.navbar-custom {
  -moz-transition: all .4s ease-in;
  -o-transition: all .4s ease-in;
  -webkit-transition: all .4s ease-in;
  transition: all .4s ease-in;
  color: variables.$font-color-light;
  background: variables.$light-color;
  height: 65px;
}

.font-13rem {
  font-size: 1.3rem;
}

.nav-menu-list {
    justify-content: space-around;
    align-items: center;
    width: 100%;
    background-color: variables.$light-color;
}

@media screen and (max-width: 800px) {
    .nav-menu-container {
      justify-content: center;
    }
    
    .small-none {
      display: none;
    }
}
</style>    